/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step1_ArtifactInputs */

const en_dr_step1_artifact = /** @type {(inputs: Dr_Step1_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem statement + status quo + cost of doing nothing`)
};

const id_dr_step1_artifact = /** @type {(inputs: Dr_Step1_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pernyataan masalah + status quo + biaya bila dibiarkan`)
};

/**
* | output |
* | --- |
* | "Problem statement + status quo + cost of doing nothing" |
*
* @param {Dr_Step1_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step1_artifact = /** @type {((inputs?: Dr_Step1_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step1_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step1_artifact(inputs)
	return en_dr_step1_artifact(inputs)
});